import { render, staticRenderFns } from "./CustomersDataTableForLazyWithResize.vue?vue&type=template&id=7d50c8ee&scoped=true&"
import script from "./CustomersDataTableForLazyWithResize.vue?vue&type=script&lang=js&"
export * from "./CustomersDataTableForLazyWithResize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d50c8ee",
  null
  
)

export default component.exports